/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Downloads_Desktop_CtaInputs */

const en_downloads_desktop_cta = /** @type {(inputs: Downloads_Desktop_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download Desktop App`)
};

const es_downloads_desktop_cta = /** @type {(inputs: Downloads_Desktop_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descargar app de escritorio`)
};

/**
* | output |
* | --- |
* | "Download Desktop App" |
*
* @param {Downloads_Desktop_CtaInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const downloads_desktop_cta = /** @type {((inputs?: Downloads_Desktop_CtaInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Downloads_Desktop_CtaInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_downloads_desktop_cta(inputs)
	return en_downloads_desktop_cta(inputs)
});